import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import * as adolescent from './../../../data/selfassesment-adolescent.json';
import * as adult from './../../../data/selfassesment-adult.json';
import * as senoir from './../../../data/selfassesment-senior.json';
import * as commonQues from './../../../data/selfassesment-common-questions.json';
import { FormBuilder, FormGroup } from '@angular/forms';
import { set } from 'date-fns';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'ngx-assesment',
  templateUrl: './assesment.component.html',
  styleUrls: ['./assesment.component.scss', '../../../../assets/css/patient-portal.css']
})
export class AssesmentComponent implements OnInit {

  isPersonalized: boolean = false;
  isNeedHelp: boolean = false;
  isAge: boolean = false;
  isBehavior: boolean = false;
  isWelcome: boolean = false;
  isLanguage: boolean = false;
  isTreatment: boolean = false;
  isBrings: boolean = false;
  isAreaImprovement: boolean = false;
  isIntro: boolean = false;
  isSelf: boolean = false;
  isCompleted: boolean = false;
  isSetUp: boolean = false;
  allAdolescent: any = (adolescent as any).default;
  allQuestions: Array<any> = [];
  commonQuestions: any = (commonQues as any).default;
  allAdult: any = (adult as any).default;
  allSenior: any = (senoir as any).default;
  commonQues: Array<any> = [];
  languageVar: any = {};
  commonLanguageVar: any = {};
  introImg:string;
  currentIndex: number = 0;
  selfAssesmentForm:FormGroup;
  showMoreOptions: boolean = false;
  @Output() logInForm: EventEmitter<any> = new EventEmitter<any>(); 
  @Output() signUpForm: EventEmitter<any> = new EventEmitter<any>(); 
  protected readonly unsubscribe$ = new Subject<void>();
  totalScore: number = 0;
  anxietyScore: number = 0;
  assessmentType: string;
  purposeList: Array<any> = [];
  areaImprovementList: Array<any> = [];

  constructor(private rolesData: RolesData,private fb:FormBuilder) {
    this.selfAssesmentForm = this.fb.group({
      age:this.fb.control(''),
      language:this.fb.control('English'),
      ageCategory:this.fb.control(''),
      problem:this.fb.control('' ),
      improvements:this.fb.control('' ),
      extra:this.fb.control('' ),
      setUp:this.fb.control('' )
    });
   }

  ngOnInit(): void {
    this.isPersonalized = true;
  }

  clickPersonalizedNext() {
    this.isPersonalized = false;
    this.isWelcome = true;
  }

  afterWelcome() {
    this.isWelcome = false;
    this.isAge = true;
  }

  clickLanguageNext() {
    const languageSelected=this.selfAssesmentForm?.get('language')?.value;
    this.commonLanguageVar= this.commonQuestions?.[languageSelected];  
    this.commonQues = this.commonLanguageVar?.quesAndOptions || [];

    this.rolesData?.list(`tenants/${environment.patientTenantId}/masterreason/${environment.patientBranchId}/GetEzoMasterById?type=PURPOSE&isActive=true`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if(data && data.details){
          const langCode = this.chooseLanguageCode(languageSelected);
            this.purposeList=data.details?.filter(each => each.mrType === 'PURPOSE' && each.isActive==true && each.reasonCode?.startsWith(langCode)  )?.sort((a, b) => {
              const numA = parseInt(a.reasonCode.replace(/\D/g, ''), 10);
              const numB = parseInt(b.reasonCode.replace(/\D/g, ''), 10);
              return numA - numB;
            })}});

    if(this.commonQues && this.commonQues.length>0){
    this.isLanguage = false;
    this.isTreatment = true;}
  }

  chooseLanguageCode(language) {
    return language == 'Tamil' ? 'TAM' : language == 'English' ? 'ENG' : language == 'Hindi' ? 'HIN' : language == 'Kannada' ? 'KAN' : language == 'Malayalam' ? 'MAL' : language == 'Marathi' ? 'MAR' : language == 'Telugu' ? 'TEL' : '';
  }

  clickTreatmentNext() {
    const languageSelected=this.selfAssesmentForm?.get('language')?.value;
    const ageCategory = this.selfAssesmentForm?.get('ageCategory')?.value;
    
    let type='ADOLESCENT';
    if (ageCategory == 1) {
      this.assessmentType='Mental Health & Behavior';
      this.introImg=this.allAdolescent?.introImg;
      this.languageVar = this.allAdolescent?.[languageSelected];
      this.purposeList = this.purposeList?.filter(each => each.reasonDescription!='not for adolescent');
       type='ADOLESCENT';}
       else if (ageCategory == 2) {
        this.assessmentType='Stress';
        this.introImg=this.allAdult?.introImg;
        this.languageVar = this.allAdult?.[languageSelected];
        type='ADULT';}
        else if (ageCategory == 3) {
          this.assessmentType='Mental Well-being & Cognitive Health';
          this.introImg=this.allSenior?.introImg;
          this.languageVar = this.allSenior?.[languageSelected];
          type='SENIOR ADULT';}
     
      this.rolesData?.list(`tenants/${environment.patientTenantId}/masterreason/${environment.patientBranchId}/GetEzoMasterById?type=${type}&isActive=true`).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (data: any) => {
          if(data && data.details){
            const langCode = this.chooseLanguageCode(languageSelected);
            this.allQuestions = data.details?.filter(each => each.mrType === type && each.isActive==true && each.reasonCode?.startsWith(langCode) )?.sort((a, b) => {
              const numA = parseInt(a.reasonCode.replace(/\D/g, ''), 10);
              const numB = parseInt(b.reasonCode.replace(/\D/g, ''), 10);
              return numA - numB;
            });
            this.allQuestions?.forEach((item, index) => {
              item.options =JSON.parse( item?.reasonDescription || '[]');
              this.selfAssesmentForm.addControl('question'+index, this.fb.control('') );
             });


             if( this.purposeList && this.purposeList.length>0){
              this.isTreatment = false;
              this.isBrings = true;                  }
          }
        }
      );
  }

  clickTreatmentBack() {
    this.isTreatment = false;
    this.isLanguage = true;
  }

  chooseAgeCategory(x) {
    this.selfAssesmentForm?.get('ageCategory')?.setValue(x?.id);
  }

  chooseProblem(id) {

    const control = this.selfAssesmentForm?.get('problem');
    const values = control?.value || [];
  
    control?.setValue(
      values.includes(id) ? values.filter(v => v !== id) : [...values, id]
    );
  }

  showMore() {
    this.showMoreOptions = !this.showMoreOptions;
  }


  submitSelfAssessment() {
    this.totalScore = 0;

    this.allQuestions.forEach((q, i) => {
      const selectedId = this.selfAssesmentForm.get('question' + i)?.value;
      if (selectedId) {
        const selectedOption = q.options.find((opt) => opt.id == selectedId);
        if (selectedOption) {
          if (q?.mrType == 'ANXIETY') {
            this.anxietyScore += selectedOption.score;
          }
          else {
            this.totalScore += selectedOption.score;
          }
        }
      }
    });

    let inputJson = this.selfAssesmentForm.value;

    if (this.assessmentType == 'Depression & Anxiety') {
      inputJson = {
        ...inputJson,
        depressionScore: this.totalScore,
        anxietyScore: this.anxietyScore
      };
      this.totalScore += this.anxietyScore;
    }

    const payload = {
      visit: 1,
      inputJson: JSON.stringify(inputJson),
      assessmentType: this.assessmentType,
      score: this.totalScore || 0,
      doctorVisibility: true,
      tenantId: environment.virtualTenant,
      branchId: environment.virtualBranch
    }

      return payload;
  }

  chooseImprovements(id) {
    const control = this.selfAssesmentForm?.get('improvements');
    let values = control?.value || [];
  
    control?.setValue(
      values.includes(id) ? values.filter(v => v !== id) : [...values, id]
    );
  }

  clickBringsNext() {
    const languageSelected=this.selfAssesmentForm?.get('language')?.value;
    this.rolesData?.list(`tenants/${environment.patientTenantId}/masterreason/${environment.patientBranchId}/GetEzoMasterById?type=IMPROVEMENTS&isActive=true`).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (data: any) => {
        if(data && data.details){
          const langCode = this.chooseLanguageCode(languageSelected);
            this.areaImprovementList=data.details?.filter(each => each.isActive==true && each.reasonCode?.startsWith(langCode)  )?.sort((a, b) => {
              const numA = parseInt(a.reasonCode.replace(/\D/g, ''), 10);
              const numB = parseInt(b.reasonCode.replace(/\D/g, ''), 10);
              return numA - numB;
            });
          
            if(this.areaImprovementList && this.areaImprovementList.length>0){
              this.isBrings = false;
              this.isAreaImprovement = true;                  }
          }});

  }

  clickAreaNext() {
    this.isAreaImprovement = false;
    this.isIntro = true;
  }

  clickIntroNext() {
    if(this.allQuestions && this.allQuestions.length>0){
    this.isIntro = false;
    this.isSelf = true;}
  }

  clickIntroBack() {
    this.isIntro = false;
    this.isAge = true;
    this.selfAssesmentForm?.reset({
      language:'English'
    });
    this.showMoreOptions = false;
  }

  clickSelfNext() {
    if (this.currentIndex >= this.allQuestions?.length - 1) {
      this.isSelf = false;
      this.isCompleted = true;
      this.currentIndex = 0;
    } else {
      this.currentIndex++;
    }
  }

  clickSelfBack() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
    else {
      this.isSelf = false;
      this.isIntro = true;
      this.allQuestions?.forEach((q, index) => {
        this.selfAssesmentForm?.get('question'+index)?.setValue('');
       });
    }
  }

  clickCompletedNext() {
    this.isCompleted = false;
    this.isSetUp = true;
  }

  clickSetUpBack() {
    this.isSetUp = false;
    this.isPersonalized = true;
    this.selfAssesmentForm?.reset({
      language:'English'
    });
    this.showMoreOptions = false;
  }

  onClickAge(arg) {
   this.selfAssesmentForm?.get('age')?.setValue(arg);
  }

  clickCancelInHelp() {
    this.isNeedHelp = false;
    this.isPersonalized = true;
    this.selfAssesmentForm?.get('age')?.setValue('');
  }

  logIn(){
    this.logInForm.emit();
  }

  signUp(){
    const returnData=this.submitSelfAssessment();
    this.signUpForm.emit(returnData);
  }


  clickAfterChooseAge() {
    this.isAge = false;

    if (this.selfAssesmentForm.get('age')?.value=='above18') {
      this.isLanguage = true;
      this.selfAssesmentForm?.get('language')?.setValue('English');
    }
    else {
      this.isNeedHelp = true;
    }
  }

  clickLanguageBack() {
    this.isLanguage = false;
    this.isAge = true;
    this.selfAssesmentForm?.get('age')?.setValue('');
  }

  chooseLanguage(language: string) {
    this.selfAssesmentForm.get('language')?.setValue(language);  
  }

}
